import { Outlet, Navigate } from 'react-router-dom';
import { useUser } from 'Components/Organisms/UserProvider/useUser';
import { ROUTES } from 'Utils/constants';
import useProjectSelected from 'Hooks/useProjectSelected';
import AppSkeleton from 'Components/Molecules/AppSkeleton/AppSkeleton';

export default function GuardOnboarding() {
    const { user } = useUser();
    const { project, isLoading } = useProjectSelected();

    if (!user) {
        return <Navigate to={ROUTES.signIn} />;
    }

    if (!user.set_project_workspace_id) {
        return <Navigate to={ROUTES.selectWorkspace} />;
    }

    if (isLoading) {
        return <AppSkeleton />;
    }

    if (project.is_onboarded) {
        return <Navigate to={ROUTES.dashboards} />;
    }

    return <Outlet />;
}
